
import { i18nText } from '@/locales';

import { Component, Vue, Watch } from "vue-property-decorator";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import EAutoComplete from "@/UI/components/EAutoComplete/EAutoComplete.vue";


import {mixins} from "vue-class-component";

@Component({
  components: {
    BaseDataForm,
    'e-auto-complete':EAutoComplete
  }
})
export default class CompleteTest extends mixins(SimpleProxyForm) {
  async created(): Promise<void> {
    try {
      //await this.getData();
      this.formReady = true;
    } catch (e) {
      console.log(i18nText("Ошибка создания формы визита -:") + e);
    }
  }
}
